import { type AlertProps, Alert as AntdAlert } from 'antd'

export const ALERT_TEST_ID = 'alert-test-id'

export function Alert({ ...props }: AlertProps) {
  return <AntdAlert data-testid={ALERT_TEST_ID} {...props} />
}
